import "core-js/modules/es6.array.map";

/** @jsx jsx */
import { css, jsx } from '@emotion/core';
import { FREEDOM_RED_DARK } from '../utilities/constants';
var ADJUST_NAV_STYLE = css({
  // boston.gov drupal side of things is calling a legacy stylesheet with font smoothing applied
  WebkitFontSmoothing: 'antialiased',
  MozOsxFontSmoothing: 'grayscale'
});
var LAST_BREADCRUMB_STYLE = css({
  color: FREEDOM_RED_DARK
});
/**
 * Breadcrumb navigation for use in Boston.gov web applications.
 *
 * Starts with a “Home” link to https://www.boston.gov, followed by any parent
 * links for the current page, and then the link for the current page.
 *
 * https://www.w3.org/TR/wai-aria-practices/#breadcrumb
 */

export default function BreadcrumbNav(props) {
  var visualSeparator = jsx("span", {
    className: "brc-s",
    style: {
      cursor: 'default'
    },
    "aria-hidden": "true"
  }, ' ', "\u203A", ' ');
  return jsx("nav", {
    className: "brc ".concat(props.className),
    css: ADJUST_NAV_STYLE,
    "aria-label": "Breadcrumbs"
  }, jsx("ul", {
    className: "brc-l"
  }, jsx("li", {
    className: "brc-l-i"
  }, jsx("a", {
    href: "https://www.boston.gov/"
  }, "Home"), visualSeparator), props.parentLinks.map(function (link) {
    return jsx("li", {
      className: "brc-l-i",
      key: link.url
    }, jsx("a", {
      href: link.url
    }, link.text), visualSeparator);
  }), jsx("li", {
    className: "brc-l-i"
  }, jsx("a", {
    href: props.currentPage.url,
    css: LAST_BREADCRUMB_STYLE,
    "aria-current": "page"
  }, props.currentPage.text))));
}